<h4 class="mb-3">
    <slot />
</h4>

<style>
    h4 {
        border-bottom: solid 1px lightgrey;
    }
    h4:not(:first-of-type) {
        margin-top: 24px;
    }
</style>
